import {useCallback} from 'react';
import {useStore} from 'react-redux';

import {getInitiatorSystems} from 'src/openapi/admin/apis/GetInitiatorSystemsApi';
import {useAppDispatch, useAppSelector} from 'src/store/hooks';

import {
    initiatorSystemsFailed, initiatorSystemsLoading, selectInitiatorSystems, selectInitiatorSystemsStatus,
} from './services/dictionary-slice';

import type {AppState} from 'src/store/typedef';

export const useInitiatorSystems = () => {
    const store = useStore<AppState>();
    const dispatch = useAppDispatch();
    const initiatorSystems = useAppSelector(selectInitiatorSystems);
    const status = useAppSelector(selectInitiatorSystemsStatus);
    const loadInitiatorSystems = useCallback(async () => {
        // Read the store directly so simultaneous consumers share the first request.
        const currentStatus = selectInitiatorSystemsStatus(store.getState());
        if (currentStatus === 'loading' || currentStatus === 'succeeded') {
            return;
        }
        store.dispatch(initiatorSystemsLoading());
        try {
            await dispatch(getInitiatorSystems());
        } catch {
            store.dispatch(initiatorSystemsFailed());
        }
    }, [dispatch, store]);
    return {initiatorSystems, status, loadInitiatorSystems};
};
